import React from 'react';

export type SelectedVariants = {
  [key: string]: { variantIndex: number; selectedVariant: string };
};

export type Experiment<T> = {
  id: string;
  baseline: T;
  variants: { [experimentId: string]: T };
};

export type ExperimentValue<T> = {
  showEditor: boolean;
  sessionId?: string;
  selectedVariants: SelectedVariants;
  viewedExperiments: {
    [experimentId: string]: { variant: string };
  };
  experiments: Array<Experiment<T>>;
  registerExperiment: (experiment: Experiment<T>) => void;
  unregisterExperiment: (id: string) => void;
  selectVariant: (experiment: Experiment<T>, variant: string) => void;
  setViewedExperiment: (experimentId: string, variant: string) => void;
};

export const ExperimentContext = React.createContext<ExperimentValue<any>>({
  showEditor: false,
  selectedVariants: {},
  viewedExperiments: {},
  experiments: [],
  registerExperiment: () => null,
  unregisterExperiment: () => null,
  selectVariant: () => null,
  setViewedExperiment: () => null,
});

ExperimentContext.displayName = 'ExperimentContext';
